import React from 'react';
import ArrowImg from '../../assets/images/arrow.svg';

function Arrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, 
          backgroundColor: 'rgba(119, 118, 236, 0.48)',
          width: 72,
          height: 72,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
      }}
      onClick={onClick}
    >
      <img src={ArrowImg} alt="Arrow" />
    </div>
  );
}

export default Arrow;
